let navWebsiteConfig = [
  {
    name: '首页',
    index: '/'
  },
  {
    name: '关于我们',
    index: '/gywm',
    children: [
      { name: '公司介绍', index: '/gywm/companyIntroduction' },
      { name: '组织架构', index: '/gywm/organizationalStructure' },
      // { name: '质量承诺', index: '/gywm/qualityCommitment' },
      { name: '发展历程', index: '/gywm/developmentHistory' },
      { name: '公司荣誉', index: '/gywm/honoraryQualification' },
    ]
  },
  {
    name: '新闻中心',
    index: '/news/companyNews',
    // children: [
    //   { name: '公司新闻', index: '/news/companyNews', children: [{ name: '新闻详情', index: '/news/newsDetail' }] },
    //   { name: '行业新闻', index: '/news/industryNews' },
    //   { name: '公示公告', index: '/news/publicAnnouncement' },
    // ]
  },
  {
    name: '服务产品',
    index: '/showProduct',
  },
  {
    name: '信息公开',
    index: '/news/industryNews',
  },
  {
    name: '联系我们',
    index: '/connectUs'
  },
  // {
  //   name: '系统管理',
  //   index: '/connectUs'
  // },
]

let navAdminConfig = [
  {
    name: '用户中心',
    index: '/',
    adminChildren: [
      { name: '用户管理', index: '/' },
      { name: '权限管理', index: '/' },
    ]
  },
  {
    name: '内容管理',
    index: '/',
    adminChildren: [
      { name: '新闻资讯', index: '/' },
      { name: '产品中心', index: '/' },
      { name: '经典案例', index: '/' },
      { name: '走进科建', index: '/' },
      { name: '下载APP', index: '/' },
    ]
  }
]

export default {
  navWebsiteConfig,
  navAdminConfig
}